"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    adminPropertyEdit: {
        path: `/backoffice/properties/:propertyId`,
    },
    adminAccountCreate: {
        path: `/admin/accounts/create`,
    },
    tasks: {
        path: `/admin/tasks`,
    },
    csvImports: {
        path: `/admin/csv-imports/:importType`,
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFja29mZmljZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvYmFja29mZmljZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtQ0FBc0M7QUFFekIsUUFBQSxNQUFNLEdBQUcsSUFBQSxtQkFBVyxFQUFDO0lBQ2hDLGlCQUFpQixFQUFFO1FBQ2pCLElBQUksRUFBRSxvQ0FBb0M7S0FDM0M7SUFDRCxrQkFBa0IsRUFBRTtRQUNsQixJQUFJLEVBQUUsd0JBQXdCO0tBQy9CO0lBQ0QsS0FBSyxFQUFFO1FBQ0wsSUFBSSxFQUFFLGNBQWM7S0FDckI7SUFDRCxVQUFVLEVBQUU7UUFDVixJQUFJLEVBQUUsZ0NBQWdDO0tBQ3ZDO0NBQ0YsQ0FBQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYnVpbGRSb3V0ZXMgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5leHBvcnQgY29uc3Qgcm91dGVzID0gYnVpbGRSb3V0ZXMoe1xuICBhZG1pblByb3BlcnR5RWRpdDoge1xuICAgIHBhdGg6IGAvYmFja29mZmljZS9wcm9wZXJ0aWVzLzpwcm9wZXJ0eUlkYCxcbiAgfSxcbiAgYWRtaW5BY2NvdW50Q3JlYXRlOiB7XG4gICAgcGF0aDogYC9hZG1pbi9hY2NvdW50cy9jcmVhdGVgLFxuICB9LFxuICB0YXNrczoge1xuICAgIHBhdGg6IGAvYWRtaW4vdGFza3NgLFxuICB9LFxuICBjc3ZJbXBvcnRzOiB7XG4gICAgcGF0aDogYC9hZG1pbi9jc3YtaW1wb3J0cy86aW1wb3J0VHlwZWAsXG4gIH0sXG59KTtcbiJdfQ==